import * as React from 'react'
import { useHistory } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { BuildingIcon, ChevronsUpDownIcon, PlusIcon } from 'lucide-react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu'
import { SidebarMenu, SidebarMenuButton, SidebarMenuItem } from '../ui/sidebar'
import { AccountantWorkspace } from '../../types'
import ERouteAccountant, { workspacePath } from '../../accountant/ERouteAccountant'

interface IProps {
  workspaces: AccountantWorkspace[]
  currentWorkspace?: AccountantWorkspace
}

export default function WorkspaceSwitcher({ workspaces, currentWorkspace }: IProps) {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <DropdownMenu>
          <DropdownMenuTrigger render={<SidebarMenuButton size='lg' />}>
            <BuildingIcon className='size-5 shrink-0' />
            <span className='truncate font-semibold'>
              {currentWorkspace ? currentWorkspace.business_name : t('Accountant::Select a client')}
            </span>
            <ChevronsUpDownIcon className='ml-auto size-4' />
          </DropdownMenuTrigger>
          <DropdownMenuContent align='start' className='min-w-56'>
            <DropdownMenuGroup>
              <DropdownMenuLabel>{t('Accountant::Clients')}</DropdownMenuLabel>
              {workspaces.map(workspace => (
                <DropdownMenuItem key={workspace.id} onClick={() => history.push(workspacePath(workspace.id))}>
                  {workspace.business_name}
                </DropdownMenuItem>
              ))}
            </DropdownMenuGroup>
            <DropdownMenuSeparator />
            <DropdownMenuItem onClick={() => history.push(ERouteAccountant.PATH_CLIENTS)}>
              <PlusIcon />
              {t('Accountant::Request access to a client')}
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </SidebarMenuItem>
    </SidebarMenu>
  )
}
